"use strict";
'app public';

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _lodash = _interopRequireDefault(require("lodash"));
var Misc = _interopRequireWildcard(require("@/helpers/Misc"));
var _CommonLayout = _interopRequireDefault(require("./CommonLayout"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
var _default = exports.default = {
  components: {
    StartupLayout: _CommonLayout.default
  },
  data() {
    return {
      connectErrors: [],
      network: null,
      network_extras: null,
      username: '',
      password: '',
      znc_network: '',
      showNetwork: true,
      showPass: true,
      showUser: true,
      show_password_box: false
    };
  },
  computed: {
    greetingText() {
      let greeting = this.$state.settings.startupOptions.greetingText;
      return typeof greeting === 'string' ? greeting : this.$t('start_greeting');
    },
    buttonText() {
      let greeting = this.$state.settings.startupOptions.buttonText;
      return typeof greeting === 'string' ? greeting : this.$t('start_button');
    },
    readyToStart() {
      return this.username && (this.password || this.showPass === false);
    },
    infoContent() {
      return this.$state.settings.startupOptions.infoContent || '';
    }
  },
  created() {
    let options = this.$state.settings.startupOptions;
    this.username = options.username || '';
    this.password = options.password || '';
    this.znc_network = window.location.hash.substr(1) || options.network || '';
    this.showNetwork = typeof options.showNetwork === 'boolean' ? options.showNetwork : true;
    this.showUser = typeof options.showUser === 'boolean' ? options.showUser : true;
    this.showPass = typeof options.showPass === 'boolean' ? options.showPass : true;
    if (options.autoConnect && this.username && this.password) {
      this.startUp();
    }
    window.test = this;
  },
  methods: {
    readableStateError(err) {
      return Misc.networkErrorMessage(err);
    },
    formSubmit() {
      if (this.readyToStart) {
        this.startUp();
      }
    },
    addNetwork(netName) {
      let options = this.$state.settings.startupOptions;
      let password = this.username;
      if (netName) {
        password += '/' + netName;
      }
      password += ':' + this.password;
      let net = this.$state.addNetwork(netName, 'ZNC', {
        server: _lodash.default.trim(options.server),
        port: options.port,
        tls: options.tls,
        password: password
      });
      return net;
    },
    startUp() {
      this.connectErrors = [];
      if (this.network) {
        this.$state.removeNetwork(this.network.id);
      }
      let netList = _lodash.default.compact(this.znc_network.split(','));
      if (netList.length === 0) {
        netList.push('');
      }

      // add our first network and make sure we can connect
      // before trying to add other networks.
      let net = this.network = this.addNetwork(netList.shift());
      this.network_extras = netList;
      let onRegistered = () => {
        this.$state.setActiveBuffer(net.id, net.serverBuffer().name);
        if (this.$refs.layout) {
          this.$refs.layout.close();
        }
        net.ircClient.off('registered', onRegistered);
        net.ircClient.off('close', onClosed);
        net.ircClient.off('irc error', onError);
        this.network_extras.forEach((netName, idx) => {
          let extraNet = this.addNetwork(_lodash.default.trim(netName));
          extraNet.ircClient.connect();
        });
      };
      let onClosed = () => {
        let lastError = this.network.last_error;
        if (lastError && !this.connectErrors.includes(lastError)) {
          this.connectErrors.push(lastError);
        }
        if (!this.connectErrors.length && !net.state_error) {
          this.connectErrors.push(this.$t('error_closed_unexpected'));
        }
        net.ircClient.off('registered', onRegistered);
        net.ircClient.off('close', onClosed);
        net.ircClient.off('irc error', onError);
      };
      let onError = event => {
        if (event.reason && !this.connectErrors.includes(event.reason)) {
          this.connectErrors.push(event.reason);
        }
      };
      net.ircClient.once('registered', onRegistered);
      net.ircClient.once('close', onClosed);
      net.ircClient.on('irc error', onError);
      net.ircClient.connect();
    }
  }
};
window._app_exports = window._app_exports || {};
if(!window._app_exports["components"]) window._app_exports["components"] = {};
if(!window._app_exports["components"]["startups"]) window._app_exports["components"]["startups"] = {};
window._app_exports["components"]["startups"]["ZncLogin"]
window._app_exports.components.startups.ZncLogin = exports.default ? exports.default : exports;
